import React from 'react';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import ImageSlider from '../ViewListing/ImageSlider/ImageSlider';

import { openImageLightBox, closeImageLightBox } from '../../actions/ImageLightBox';
import { photosShow } from '../../helpers/photosShow';
import { claimImagesUploadDir } from '../../config';
import { isRTL } from '../../helpers/formatLocale';
import closeIcon from '/public/SiteIcons/claimPhotoClose.svg';

import cs from 'swiper/swiper-bundle.css';
import t from '../../styles/customSwiper.css';
import s from './HostClaimModal.css';


const SampleNextArrow = ({ className }) => (
    <div className={className}>
        <svg viewBox="0 0 18 18" role="img" aria-label="Previous" focusable="false">
            <path d="m4.29 1.71a1 1 0 1 1 1.42-1.41l8 8a1 1 0 0 1 0 1.41l-8 8a1 1 0 1 1 -1.42-1.41l7.29-7.29z"></path>
        </svg>
    </div>
);

const SamplePrevArrow = ({ className }) => (
    <div className={className}>
        <svg viewBox="0 0 18 18" role="img" aria-label="Previous" focusable="false">
            <path d="m13.7 16.29a1 1 0 1 1 -1.42 1.41l-8-8a1 1 0 0 1 0-1.41l8-8a1 1 0 1 1 1.42 1.41l-7.29 7.29z"></path>
        </svg>
    </div>
);
class ClaimImagesSlider extends React.Component {

    constructor(props) {
        super(props);
        this.swiper = React.createRef();
        if (typeof window !== 'undefined') {
            this.swiperPackage = require('swiper/react');
            this.swiperModule = require('swiper/modules')
        }
    }

    openSliderClick = (index) => {
        const { openImageLightBox } = this.props;
        openImageLightBox(index);
    }

    render() {
        const { data, intl: { locale }, arrow, claimed, removeImage, imageLightBox, closeImageLightBox, isUploadComplete, currentIndex } = this.props;
        const { Swiper, SwiperSlide } = this.swiperPackage;
        const { Navigation } = this.swiperModule;
        const rtl = isRTL(locale);

        const params = {
            speed: 600,
            slidesPerView: 2,
            spaceBetween: 20,
            modules: [Navigation],
            navigation: {
                nextEl: `.claimImageSwiperNavigationNextBtn`,
                prevEl: `.claimImageSwiperNavigationPrevBtn`,
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 2,
                },
                // when window width is >= 576px
                576: {
                    slidesPerView: 3,
                },
                // when window width is >= 641px
                641: {
                    slidesPerView: 4,
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 4,
                },
            }
        }
        let imagePath = photosShow(claimImagesUploadDir)

        return (
            <div className={cx(s.positionRelative, s.sliderBottom, 'claimModalSlider', 'claimModalSliderRTL', { ['claimModalImgCloseIcon']: !claimed })}>
                {<ImageSlider
                    imageLightBox={imageLightBox}
                    closeImageLightBox={closeImageLightBox}
                    sources={data.map(value => ({ src: `${imagePath}${value}` }))}
                    currentImage={currentIndex + 1}
                />}
                <Swiper {...params} key={rtl} dir={rtl ? 'rtl' : 'ltr'} ref={this.swiper} className={cx('row homeSlickSlider')}>
                    {
                        data && data.map((item, index) => {
                            return (
                                <SwiperSlide>
                                    <div className={cx(s.claimImageSection, 'claimImageSection')}>
                                        <div className={s.bgImage} style={{ backgroundImage: `url(${imagePath}${item}` }} onClick={() => !isUploadComplete && this.openSliderClick(index)}></div>
                                        {!claimed && <a onClick={() => removeImage(item)}><img src={closeIcon} className={cx(s.closeIcon, 'claimImageCloseIconRTL')} /></a>}
                                    </div>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
                <div>
                    {arrow && data && <SamplePrevArrow className={'claimImageSwiperNavigationPrevBtn'} />}
                    {arrow && data && <SampleNextArrow className={'claimImageSwiperNavigationNextBtn'} />}
                </div>
            </div>
        )
    }
}
const mapState = (state) => ({
    imageLightBox: state?.viewListing?.imageLightBox,
    currentIndex: state.viewListing.currentIndex
})
const mapDispatch = ({
    openImageLightBox,
    closeImageLightBox
})
export default injectIntl(withStyles(cs, t, s)(connect(mapState, mapDispatch)(ClaimImagesSlider)));